var _       = require('underscore');
var $       = require('jquery');
var Core    = require('../core/core.js');

/**
 * Creates a sidebar group item
 *
 * @class
 */

class SidebarVersionsDraftItem extends Core {

    _defaults() {
        return {
            target: '.js-editor',
            fields: {}
        };
    }

    constructor(options) {
        super(options);

        this.template = `
            <div>
                <div class="editor__sidebar__versions__item js-editor__sidebar__busy">
                    <div class="editor__sidebar__versions__item__title">Saving...</div>
                </div>

                <div class="js-editor__sidebar__notbusy">
                    <div class="editor__sidebar__versions__item editor__sidebar__versions__item--draft js-editor__sidebar__draftinfo">
                        <div class="editor__sidebar__versions__item__title">Draft</div>
                        <div class="editor__sidebar__versions__item__description js-editor__sidebar__versions__item__description"></div>
                        <a class='vertical-spacing--top--half btn btn--s btn--none_base_base js-toggle_draft'>
                            <div class='btn__txt'>Create a version</div>
                        </a>
                    </div>

                    <div class="editor__sidebar__versions__item js-editor__sidebar__draftcreation">
                        Version <input class="editor__sidebar__versions__item__textinput js-name_input" type='text' readonly='true'></input>
                        <textarea class="editor__sidebar__versions__item__textinput editor__sidebar__versions__item__textinput--description js-description_input" type='text' placeholder='No description'></textarea>
                        <a class='btn btn--s btn--base_white_base js-create_button'>
                            <div class='btn__txt'>Create</div>
                        </a>
                        <a class='btn btn--s btn--none_base_borders js-cancel_button'>
                            <div class='btn__txt'>Cancel</div>
                        </a>
                    </div>
                </div>
            </div>
        `;

        super.render();

        $('.js-create_button', this.$el).on('click', this._createButtonClicked);
        $('.js-cancel_button', this.$el).on('click', this._draftButtonClicked);
        $('.js-toggle_draft', this.$el).on('click', this._draftButtonClicked);
    }

    _createButtonClicked(e){
        e.preventDefault();
        $(e.currentTarget).trigger('Cioui:VersionsSidebarItem:createButtonClicked', [e, $('.js-name_input', this.$el).val(), $('.js-description_input', this.$el).val()]);
    }

    _draftButtonClicked(e){
        e.preventDefault();
        $(e.currentTarget).trigger('Cioui:VersionsSidebarItem:draftButtonClicked');
    }

    setDraftVersion(version, nextVersion){
        $('.js-editor__sidebar__versions__item__description', this.$el).html("Version "+version+" + changes");
        $('.js-name_input', this.$el).val(nextVersion);
        $('.js-toggle_draft', this.$el).show();
    }

    setNoNewChanges(){
        $('.js-editor__sidebar__versions__item__description', this.$el).html("No new changes yet.");
        $('.js-toggle_draft', this.$el).hide();
    }

    showDraftCreation(){
        $('.js-editor__sidebar__draftcreation', this.$el).show();
        $('.js-editor__sidebar__draftinfo', this.$el).hide();
    }

    hideDraftCreation(){
        $('.js-editor__sidebar__draftcreation', this.$el).hide();
        $('.js-editor__sidebar__draftinfo', this.$el).show();
    }

    showBusy(){
        $('.js-editor__sidebar__busy', this.$el).show();
        $('.js-editor__sidebar__notbusy', this.$el).hide();
    }

    hideBusy(){
        $('.js-editor__sidebar__busy', this.$el).hide();
        $('.js-editor__sidebar__notbusy', this.$el).show();
    }
}
module.exports = SidebarVersionsDraftItem;
